import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
// KV records that belong to the new server modules. The KV collection is legacy and published to every client
// (GitHub #18). These records decide things (who was migrated, which polygon list is active), so they are not
// published, and saveKV, which takes only the keys listed below (#521), never writes them. The server modules write
// them directly.
import { KV_POLYGON_LISTS, KV_MIGRATION_OWNER_STATUS, KV_MIGRATION_OWNER_STATUS_DRY_RUN } from "../owners/rules"; // the doubled score rows the maintenance task removed, for its Roll back (#406)

export var KV_SCORE_DUPLICATES = 'MIGRATION_SCORE_DUPLICATES'; // the point pledges the maintenance task turned into areas, for its Roll back (#470)

export var KV_PLEDGE_POINTS = 'MIGRATION_PLEDGE_POINTS'; // the area facts (#533): the secret behind the research export's pseudonymous fan ids, and the bundle imported last

export var KV_AREA_FACTS_SECRET = 'AREA_FACTS_SECRET';
export var KV_AREA_FACTS = 'AREA_FACTS'; // whether the area facts are switched on (Maintenance, "Area facts"): off until a superadmin switches them on. Published
// (the browser hides the communities' menu item while off), written by the server only

export var KV_AREA_FACTS_ON = 'AREA_FACTS_ON';
export var SERVER_OWNED_KV_KEYS = [KV_POLYGON_LISTS, KV_MIGRATION_OWNER_STATUS, KV_MIGRATION_OWNER_STATUS_DRY_RUN, KV_SCORE_DUPLICATES, KV_PLEDGE_POINTS, KV_AREA_FACTS_SECRET, KV_AREA_FACTS, KV_AREA_FACTS_ON]; // no screen reads them from the publication (what the screens need comes through methods), except the area facts'
// switch: a yes or no

export var UNPUBLISHED_KV_KEYS = SERVER_OWNED_KV_KEYS.filter(function (key) {
  return key !== KV_AREA_FACTS_ON;
});
export var isServerOwnedKvKey = function isServerOwnedKvKey(key) {
  return SERVER_OWNED_KV_KEYS.includes(key);
}; // what the admin screens may change through saveKV (#521): the e-mail templates (Email templates) and how much a fan's
// score grows per action (Scores). Any other key is refused.

export var EMAIL_TEMPLATE_KEYS = ['REGISTERED_WELCOME_FAN', 'REGISTERED_WELCOME_OWNER', 'FORGOT_PASSWORD', 'REGISTER_REMINDER_NO_AREAS_1', 'REGISTER_REMINDER_HAS_AREAS_1', 'COMMUNITY_MESSAGE', 'MEETING_INVITED', 'MEETING_SELECTED'];
export var SCORE_KEYS = ['DRAW_AREA', 'ADD_VIRTUAL_FUNDING', 'ADD_DISCUSSION_COMMENT', 'FUND_PLEDGE'];